import { Button } from "antd";
import React from "react";
import Loader from "../Loader";

export default function MobileButton({
  text = "BACK",
  className = "",
  onClick = () => {},
  onSubmit = () => {},
  disabled = false,
  loading = false,
  ...otherProps
}) {
  return (
    <>
      <Button
        {...otherProps}
        type="primary"
        size="large"
        className={`back-btn-large hide_on_desktop show_on_mobile ${className}`}
        onClick={onClick}
        onSubmit={onSubmit}
        disabled={disabled}
      >
        {text}
      </Button>

      {loading && <Loader />}
    </>
  );
}
